<app-navbar>
	<button class="btn btn-warning me-2" (click)="print()">
		<i class="fas fa-print"></i>
		Drukuj
	</button>
	<a routerLink="/residentTripReservationList" class="btn btn-danger"> <i class="fas fa-times"></i> Zamknij </a>
</app-navbar>

<div class="row">
	<div class="col-6" *ngIf="documentType === 'ticket'">
		<div class="row mb-2">
			<div class="col">
				<img src="/assets/logo.png" alt="OSKAR" />
			</div>
		</div>
		<div class="col">
			<table class="table table-bordered border-dark">
				<tr>
					<th class="align-center">Rezerwacja:</th>
					<td colspan="2">
						<span class="d-block">
							{{ data?.reservationNumber }}
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-top">Uczestnicy:</th>
					<td colspan="2">
						<span class="d-block">
							<span *ngFor="let item of data.person">{{ item.firstName }} {{ item.lastName }}, </span>
						</span>
					</td>
				</tr>
				<tr *ngFor="let item of data.trip">
					<th class="align-top">Wycieczka</th>
					<td colspan="2">
						<span class="d-block">
							<span>{{ item.name }}</span>
						</span>
						<span class="d-block">
							<span>data: {{ item.date }}</span>
						</span>
						<span class="d-block">
							<span>godzina: {{ item.time }}</span>
						</span>
						<span class="d-block">
							<span>zbiróka: {{ item.address }}</span>
						</span>
						<span class="d-block"
							>Uwagi:
							<span [innerHTML]="item.description"></span>
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-center">Cena [EUR]:</th>
					<td colspan="2">
						<span class="d-block">
							{{ data?.priceEUR }}
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-center">Cena [HR]:</th>
					<td colspan="2">
						<span class="d-block">
							{{ data?.priceHR }}
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-center">Sprzedano przez:</th>
					<td colspan="2">
						<span class="d-block"> {{ createdBy?.firstName }} {{ createdBy?.lastName }} </span>
					</td>
				</tr>
			</table>
			<button
				class="btn ms-2"
				[ngClass]="{ 'btn-success': data.status, 'btn-outline-danger': !data.status }"
				(click)="cancel(data)"
			>
				<i></i> {{ btnLabel }}
			</button>
		</div>
	</div>
	<div class="col-6" *ngIf="documentType === 'ticket'">
		<div class="row mb-2">
			<div class="col">
				<img src="/assets/logo.png" alt="OSKAR" />
			</div>
		</div>
		<div class="col">
			<table class="table table-bordered border-dark">
				<tr>
					<th class="align-center">Rezerwacja:</th>
					<td colspan="2">
						<span class="d-block">
							{{ data?.reservationNumber }}
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-top">Uczestnicy:</th>
					<td colspan="2">
						<span class="d-block">
							<span *ngFor="let item of data.person">{{ item.firstName }} {{ item.lastName }}, </span>
						</span>
					</td>
				</tr>
				<tr *ngFor="let item of data.trip">
					<th class="align-top">Wycieczka</th>
					<td colspan="2">
						<span class="d-block">
							<span>{{ item.name }}</span>
						</span>
						<span class="d-block">
							<span>data: {{ item.date }}</span>
						</span>
						<span class="d-block">
							<span>godzina: {{ item.time }}</span>
						</span>
						<span class="d-block">
							<span>zbiróka: {{ item.address }}</span>
						</span>
						<span class="d-block"
							>Uwagi:
							<span [innerHTML]="item.description"></span>
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-center">Cena [EUR]:</th>
					<td colspan="2">
						<span class="d-block">
							{{ data?.priceEUR }}
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-center">Cena [HR]:</th>
					<td colspan="2">
						<span class="d-block">
							{{ data?.priceHR }}
						</span>
					</td>
				</tr>
				<tr>
					<th class="align-center">Sprzedano przez:</th>
					<td colspan="2">
						<span class="d-block"> {{ createdBy?.firstName }} {{ createdBy?.lastName }} </span>
					</td>
				</tr>
			</table>
		</div>
	</div>
</div>
